import React from "react";
import { Link } from "react-router-dom";

export default function IndianTaxFiling() {
  return (
    <>
      {/* Spacer for sticky header */}
      <div className="spacer spacer-30" />

      {/* Hero section */}
      <section className="py-6 bg-white position-relative overflow-hidden">
        <div className="container">
          <div className="row align-items-center gy-4">
            <div className="col-lg-12" data-aos="fade-right">
              <h1
                className="fw-bold mb-3 text-center"
                style={{
                  fontFamily: "'Poppins', sans-serif",
                  color: "#283870",
                  fontSize: "2.8rem",
                  lineHeight: 1.2,
                  padding: '50px'
                }}
              >
                Indian Tax Filing
              </h1>
              <p
                className="fs-5 text-secondary text-center"
                style={{ maxWidth: 800, margin: "0 auto" }}
              >
                Comprehensive tax filing services for individuals and businesses in India.
                Expert assistance with income tax, GST, registrations, and compliance.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="py-5" style={{ background: "#fff" }}>
        <div className="container" style={{ maxWidth: "1200px" }}>

          {/* Heading 1: INCOME TAX */}
          <div className="mb-5">
            <h2
              className="fw-bold mb-4"
              style={{
                color: "#d53f8c",
                fontFamily: "'Poppins',sans-serif",
                fontSize: "2rem",
                borderBottom: "3px solid #d53f8c",
                paddingBottom: "10px"
              }}
            >
              1. INCOME TAX
            </h2>

            <div className="row g-4 mb-4">
              <div className="col-md-6">
                <h4 className="fw-semibold mb-3" style={{ color: "#6B46C1" }}>
                  Income Tax Filings
                </h4>
                <p style={{ color: "#444", lineHeight: 1.8 }}>
                  Professional assistance with filing your annual income tax returns (ITR) in India.
                  We ensure accurate calculations, proper documentation, and timely submission to avoid penalties.
                </p>
              </div>

              <div className="col-md-6">
                <h4 className="fw-semibold mb-3" style={{ color: "#6B46C1" }}>
                  Income Tax Notices
                </h4>
                <p style={{ color: "#444", lineHeight: 1.8 }}>
                  Expert handling of income tax notices from the IT Department. We help you respond
                  effectively, resolve disputes, and ensure compliance with all tax requirements.
                </p>
              </div>

              <div className="col-md-6">
                <h4 className="fw-semibold mb-3" style={{ color: "#6B46C1" }}>
                  15CA-15CB Filings
                </h4>
                <p style={{ color: "#444", lineHeight: 1.8 }}>
                  Complete support for Form 15CA and 15CB filings required for foreign remittances.
                  We ensure proper documentation and compliance with RBI regulations for international transactions.
                </p>
              </div>

              <div className="col-md-6">
                <h4 className="fw-semibold mb-3" style={{ color: "#6B46C1" }}>
                  TDS Filings
                </h4>
                <p style={{ color: "#444", lineHeight: 1.8 }}>
                  Comprehensive TDS (Tax Deducted at Source) filing services including quarterly returns,
                  TDS certificates, and compliance with all TDS provisions under the Income Tax Act.
                </p>
              </div>
            </div>
          </div>

          {/* Heading 2: TAX ON SALE OF PROPERTY BY / TO NRI */}
          <div className="mb-5">
            <h2
              className="fw-bold mb-4"
              style={{
                color: "#d53f8c",
                fontFamily: "'Poppins',sans-serif",
                fontSize: "2rem",
                borderBottom: "3px solid #d53f8c",
                paddingBottom: "10px"
              }}
            >
              2. TAX ON SALE OF PROPERTY BY / TO NRI
            </h2>

            <div className="row">
              <div className="col-12">
                <p style={{ color: "#444", lineHeight: 1.8, fontSize: "1.1rem" }}>
                  Specialized tax services for Non-Resident Indians (NRIs) buying or selling property in India.
                  We handle capital gains tax calculations, TDS compliance, repatriation procedures, and ensure
                  proper documentation for both NRI sellers and buyers as per Indian tax laws.
                </p>
              </div>
            </div>
          </div>

          {/* Table Section */}
          <div className="mb-5">
            <h2
              className="fw-bold mb-4"
              style={{
                color: "#d53f8c",
                fontFamily: "'Poppins',sans-serif",
                fontSize: "2rem",
                borderBottom: "3px solid #d53f8c",
                paddingBottom: "10px"
              }}
            >
              Tax on Sale of Property: NRI vs Resident Comparison
            </h2>

            <div className="table-responsive" style={{ marginTop: "30px" }}>
              <table className="table table-bordered table-hover" style={{ fontSize: "0.95rem" }}>
                <thead style={{ background: "linear-gradient(90deg, #6B46C1, #D53F8C)", color: "white" }}>
                  <tr>
                    <th style={{ padding: "15px", fontWeight: "600" }}>Particulars</th>
                    <th style={{ padding: "15px", fontWeight: "600" }}>Case 1: NRI Seller – Resident Buyer</th>
                    <th style={{ padding: "15px", fontWeight: "600" }}>Case 2: Resident Seller – NRI Buyer</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ padding: "12px", fontWeight: "600", background: "#f8f9fa" }}>Who Sells / Who Buys</td>
                    <td style={{ padding: "12px" }}>Seller = NRI<br />Buyer = Resident</td>
                    <td style={{ padding: "12px" }}>Seller = Resident<br />Buyer = NRI</td>
                  </tr>
                  <tr>
                    <td style={{ padding: "12px", fontWeight: "600", background: "#f8f9fa" }}>Applicable Tax on Seller</td>
                    <td style={{ padding: "12px" }}>
                      Capital Gains Tax on sale proceeds:<br />
                      • LTCG (&gt;2 yrs): 20% with indexation (if bought before 23 Jul 2024) / 12.5% without (after)<br />
                      • STCG (≤2 yrs): at slab rate (~30%)
                    </td>
                    <td style={{ padding: "12px" }}>
                      Seller (Resident) taxed normally under Indian slabs on capital gains.
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "12px", fontWeight: "600", background: "#f8f9fa" }}>TDS Deduction by Buyer</td>
                    <td style={{ padding: "12px" }}>
                      Buyer must deduct TDS on full consideration:<br />
                      • LTCG – 20% (+ surcharge/cess)<br />
                      • STCG – 30% (+ surcharge/cess)
                    </td>
                    <td style={{ padding: "12px" }}>
                      Buyer must deduct 1% TDS (u/s 194-IA) if sale value &gt; ₹50 L.
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "12px", fontWeight: "600", background: "#f8f9fa" }}>TDS Deposit Form</td>
                    <td style={{ padding: "12px" }}>
                      Buyer files Form 27Q and issues Form 16A to NRI seller.
                    </td>
                    <td style={{ padding: "12px" }}>
                      Buyer files Form 26QB and issues Form 16B to resident seller.
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "12px", fontWeight: "600", background: "#f8f9fa" }}>Lower/NIL TDS Certificate</td>
                    <td style={{ padding: "12px" }}>
                      NRI seller can apply to IT Dept for lower/nil TDS before sale.
                    </td>
                    <td style={{ padding: "12px" }}>
                      Not applicable (resident's TDS fixed at 1%).
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "12px", fontWeight: "600", background: "#f8f9fa" }}>Mode of Payment</td>
                    <td style={{ padding: "12px" }}>
                      Payment in Indian Rupees via NRO account or Indian bank channel.
                    </td>
                    <td style={{ padding: "12px" }}>
                      Payment via NRE/NRO/FCNR account or inward remittance through bank.
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "12px", fontWeight: "600", background: "#f8f9fa" }}>FEMA / RBI Permission</td>
                    <td style={{ padding: "12px" }}>
                      Not needed for selling.
                    </td>
                    <td style={{ padding: "12px" }}>
                      No prior RBI approval required to buy residential/commercial property.
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "12px", fontWeight: "600", background: "#f8f9fa" }}>Forms for Repatriation</td>
                    <td style={{ padding: "12px" }}>
                      Form 15CA & 15CB needed for remitting sale proceeds abroad.
                    </td>
                    <td style={{ padding: "12px" }}>
                      For repatriation of funds later (e.g. rent/sale income), same Form 15CA/CB applies.
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "12px", fontWeight: "600", background: "#f8f9fa" }}>Tax-Saving Options</td>
                    <td style={{ padding: "12px" }}>
                      LTCG exemption via Sec 54 (new house) / Sec 54EC (bonds) / Sec 54F (other asset).
                    </td>
                    <td style={{ padding: "12px" }}>
                      Not applicable at purchase stage.
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "12px", fontWeight: "600", background: "#f8f9fa" }}>Max Repatriation Allowed</td>
                    <td style={{ padding: "12px" }}>
                      Up to USD 1 million/year (with docs & CA certificate).
                    </td>
                    <td style={{ padding: "12px" }}>
                      Funds for purchase can come from NRE/NRO/FCNR; no cap on inflow.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Heading 3: REGISTRATIONS */}
          <div className="mb-5">
            <h2
              className="fw-bold mb-4"
              style={{
                color: "#d53f8c",
                fontFamily: "'Poppins',sans-serif",
                fontSize: "2rem",
                borderBottom: "3px solid #d53f8c",
                paddingBottom: "10px"
              }}
            >
              3. REGISTRATIONS
            </h2>

            <div className="row g-4 mb-4">
              <div className="col-md-6">
                <h4 className="fw-semibold mb-3" style={{ color: "#6B46C1" }}>
                  Private Limited
                </h4>
                <p style={{ color: "#444", lineHeight: 1.8 }}>
                  Complete assistance with Private Limited company registration including name approval,
                  incorporation documents, and post-registration compliance requirements.
                </p>
              </div>

              <div className="col-md-6">
                <h4 className="fw-semibold mb-3" style={{ color: "#6B46C1" }}>
                  One Person Company
                </h4>
                <p style={{ color: "#444", lineHeight: 1.8 }}>
                  Expert guidance for One Person Company (OPC) registration, a popular business structure
                  for solo entrepreneurs with limited liability benefits.
                </p>
              </div>

              <div className="col-md-6">
                <h4 className="fw-semibold mb-3" style={{ color: "#6B46C1" }}>
                  LLP Registration
                </h4>
                <p style={{ color: "#444", lineHeight: 1.8 }}>
                  Professional support for Limited Liability Partnership (LLP) registration, combining
                  the benefits of partnership and company structures with simplified compliance.
                </p>
              </div>

              <div className="col-md-6">
                <h4 className="fw-semibold mb-3" style={{ color: "#6B46C1" }}>
                  Firm Registration
                </h4>
                <p style={{ color: "#444", lineHeight: 1.8 }}>
                  Assistance with Partnership Firm registration including partnership deed preparation,
                  registration with Registrar of Firms, and compliance documentation.
                </p>
              </div>

              <div className="col-md-6">
                <h4 className="fw-semibold mb-3" style={{ color: "#6B46C1" }}>
                  Trust 12A & 80G Registration
                </h4>
                <p style={{ color: "#444", lineHeight: 1.8 }}>
                  Complete support for Trust registration and obtaining 12A and 80G certificates for
                  tax exemptions and donation benefits under the Income Tax Act.
                </p>
              </div>

              <div className="col-md-6">
                <h4 className="fw-semibold mb-3" style={{ color: "#6B46C1" }}>
                  Section 8 Company
                </h4>
                <p style={{ color: "#444", lineHeight: 1.8 }}>
                  Expert assistance with Section 8 Company registration for non-profit organizations,
                  including license application and compliance with charitable organization requirements.
                </p>
              </div>

              <div className="col-md-6">
                <h4 className="fw-semibold mb-3" style={{ color: "#6B46C1" }}>
                  ICEGATE Registration
                </h4>
                <p style={{ color: "#444", lineHeight: 1.8 }}>
                  Support for ICEGATE (Indian Customs EDI Gateway) registration for import-export businesses,
                  enabling electronic filing of customs documents and seamless trade operations.
                </p>
              </div>

              <div className="col-md-6">
                <h4 className="fw-semibold mb-3" style={{ color: "#6B46C1" }}>
                  FCRA Registration
                </h4>
                <p style={{ color: "#444", lineHeight: 1.8 }}>
                  Professional assistance with Foreign Contribution Regulation Act (FCRA) registration for
                  organizations receiving foreign contributions, ensuring compliance with regulatory requirements.
                </p>
              </div>
            </div>
          </div>

          {/* Heading 4: LICENCES */}
          <div className="mb-5">
            <h2
              className="fw-bold mb-4"
              style={{
                color: "#d53f8c",
                fontFamily: "'Poppins',sans-serif",
                fontSize: "2rem",
                borderBottom: "3px solid #d53f8c",
                paddingBottom: "10px"
              }}
            >
              4. LICENCES
            </h2>

            <div className="row g-4 mb-4">
              <div className="col-md-6">
                <h4 className="fw-semibold mb-3" style={{ color: "#6B46C1" }}>
                  Import and Export Code
                </h4>
                <p style={{ color: "#444", lineHeight: 1.8 }}>
                  Complete assistance with IEC (Import Export Code) registration required for international
                  trade, including application filing and compliance with DGFT regulations.
                </p>
              </div>

              <div className="col-md-6">
                <h4 className="fw-semibold mb-3" style={{ color: "#6B46C1" }}>
                  MSME UDAYM
                </h4>
                <p style={{ color: "#444", lineHeight: 1.8 }}>
                  Support for MSME (Micro, Small & Medium Enterprises) registration under UDYAM portal,
                  enabling access to government benefits, subsidies, and priority sector lending.
                </p>
              </div>

              <div className="col-md-6">
                <h4 className="fw-semibold mb-3" style={{ color: "#6B46C1" }}>
                  PT, ESI, PF Registrations
                </h4>
                <p style={{ color: "#444", lineHeight: 1.8 }}>
                  Comprehensive support for Professional Tax (PT), Employee State Insurance (ESI), and
                  Provident Fund (PF) registrations, ensuring compliance with labor laws and statutory requirements.
                </p>
              </div>

              <div className="col-md-6">
                <h4 className="fw-semibold mb-3" style={{ color: "#6B46C1" }}>
                  Food Licence
                </h4>
                <p style={{ color: "#444", lineHeight: 1.8 }}>
                  Expert assistance with FSSAI (Food Safety and Standards Authority of India) license
                  registration for food businesses, ensuring compliance with food safety regulations.
                </p>
              </div>
            </div>
          </div>

          {/* Heading 5: GST FILINGS */}
          <div className="mb-5">
            <h2
              className="fw-bold mb-4"
              style={{
                color: "#d53f8c",
                fontFamily: "'Poppins',sans-serif",
                fontSize: "2rem",
                borderBottom: "3px solid #d53f8c",
                paddingBottom: "10px"
              }}
            >
              5. GST FILINGS
            </h2>

            <div className="row">
              <div className="col-12">
                <h4 className="fw-semibold mb-3" style={{ color: "#6B46C1" }}>
                  GST Registration and Return Filings
                </h4>
                <p style={{ color: "#444", lineHeight: 1.8, fontSize: "1.1rem" }}>
                  Complete GST (Goods and Services Tax) services including new registration, amendment of
                  existing registration, and monthly/quarterly/annual return filings. We ensure accurate
                  GST calculations, proper input tax credit claims, and timely compliance to avoid penalties.
                </p>
              </div>
            </div>
          </div>

          {/* Heading 6: OTHERS */}
          <div className="mb-5">
            <h2
              className="fw-bold mb-4"
              style={{
                color: "#d53f8c",
                fontFamily: "'Poppins',sans-serif",
                fontSize: "2rem",
                borderBottom: "3px solid #d53f8c",
                paddingBottom: "10px"
              }}
            >
              6. OTHERS
            </h2>

            <div className="row g-4 mb-4">
              <div className="col-md-6">
                <h4 className="fw-semibold mb-3" style={{ color: "#6B46C1" }}>
                  Book Keeping
                </h4>
                <p style={{ color: "#444", lineHeight: 1.8 }}>
                  Professional bookkeeping services to maintain accurate financial records, including
                  accounting entries, ledger maintenance, and preparation of financial statements.
                </p>
              </div>

              <div className="col-md-6">
                <h4 className="fw-semibold mb-3" style={{ color: "#6B46C1" }}>
                  Annual Compliances
                </h4>
                <p style={{ color: "#444", lineHeight: 1.8 }}>
                  Comprehensive annual compliance services including annual returns filing, statutory
                  audit support, and ensuring adherence to all regulatory requirements throughout the year.
                </p>
              </div>

              <div className="col-md-6">
                <h4 className="fw-semibold mb-3" style={{ color: "#6B46C1" }}>
                  Trade Mark Registration
                </h4>
                <p style={{ color: "#444", lineHeight: 1.8 }}>
                  Expert assistance with trademark registration in India, including trademark search,
                  application filing, and protection of your brand identity and intellectual property rights.
                </p>
              </div>
            </div>
          </div>

          

        </div>
      </section>

      {/* CTA Section */}
      <section className="py-5 bg-gradient-to-r from-purple-700 to-pink-600 text-white text-center position-relative overflow-hidden" style={{ marginTop: "50px" }}>
        <div className="container" style={{ maxWidth: "1200px" }}>
          <h2 className="display-5 fw-bold mb-4" style={{ fontFamily: "Poppins, sans-serif", color: "#fff" }}>
            Need Expert Assistance with Indian Tax Filing?
          </h2>
          <p className="lead mb-5 opacity-90">
            Connect with Nexen Consulting's skilled tax professionals for personalized help with
            Indian tax filing, registrations, and compliance — ensuring accuracy, timeliness, and peace of mind.
          </p>
          <div className="d-flex justify-content-center">
            <Link
              to="/contact"
              className="btn btn-lg rounded-pill fw-bold text-white px-5 py-3"
              style={{
                background: 'linear-gradient(90deg, #6B46C1, #D53F8C)',
                boxShadow: '0 4px 15px rgba(213, 63, 140, 0.6)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 8px 30px rgba(213, 63, 140, 0.9)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(213, 63, 140, 0.6)';
              }}
            >
              Get in Touch
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

